module.exports = __webpack_public_path__ + "202408221624/img/animation_kaixin.e2393628.png";